<header class="flux-header clearfix" [attr.nav-layout]="navLayout"
  [attr.navbar-type]="toggleStatus ? defaultNavbar : toggleNavbar " [attr.effect-type]="navbarEffect"
  [attr.header-theme]="headerColorTheme" [attr.collapsed-left-header]="collapsedLeftHeader"
  [attr.device-type]="deviceType">
  <div class="flux-header-wrapper clearfix">
    <div class="flux-brand" [attr.left-header-theme]="leftHeaderColorTheme" style="text-align:center">
    نظام إدارة الملاعب
    </div>
    <div class="flux-header-navbar">
      <div class="flux-left-header clearfix">
        <div class="sidebarToggle" (click)="changeTheToggleStatus()"><i class="fas fa-bars"></i></div>

      </div>

      <div class="flux-right-header clearfix">
        <ul>

      
          <nz-dropdown-menu #menu="nzDropdownMenu">
            <ul nz-menu>
              <li nz-menu-item  (click)="Language('fr')">English</li>
              <li nz-menu-item (click)="Language('ar')" > <span class="arabic-label">العربية</span> </li>
            </ul>
          </nz-dropdown-menu>
          <li><a nz-dropdown [nzDropdownMenu]="menu"> <i class="fa-solid fa-globe"></i></a></li>
         
          <li><a (click)="logout()"><i class="fas fa-power-off"></i></a></li>
        </ul>
      </div>
    </div>
  </div>
</header>
